<template>
  <div id="app" class="app-container" :class="platformClass">
    <!-- 主要内容 -->
    <router-view />

    <!-- 全局Toast容器 -->
    <van-toast />

    <!-- 全局Dialog容器 -->
    <van-dialog />
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useAppStore } from "@/stores/app.js";
import { stopAudio, cleanupAudio } from "@/composables/useAudio.js";

const appStore = useAppStore();

// 计算属性
const platformClass = computed(() => appStore.platformClass);

// 处理页面可见性变化
const handleVisibilityChange = () => {
  if (document.hidden) {
    // 页面隐藏时暂停音频
    stopAudio();
  }
};

// 处理页面卸载
const handleBeforeUnload = () => {
  // 清理音频资源
  cleanupAudio();
};

onMounted(() => {
  // 只处理全局事件监听
  document.addEventListener("visibilitychange", handleVisibilityChange);
  window.addEventListener("beforeunload", handleBeforeUnload);
});

onUnmounted(() => {
  // 清理事件监听
  document.removeEventListener("visibilitychange", handleVisibilityChange);
  window.removeEventListener("beforeunload", handleBeforeUnload);

  // 清理音频资源
  cleanupAudio();
});
</script>

<style lang="scss">
.app-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #f5f5f5;
  position: relative;
}




.is-desktop {
  // 桌面端特殊样式
  max-width: 480px;
  margin: 0 auto;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
</style>
